export default {
  brand: "A&A MOTORS",
  tagline: "हर ड्राइव. हर लाइफ़स्टाइल.",
  slogan: "सभी कारें. सभी स्टाइल. एक नाम.",
  nav: {
    fleet: "फ़्लीट",
    noDeposit: "बिना डिपॉज़िट",
    how: "कैसे काम करता है",
    about: "हमारे बारे में",
    faq: "सामान्य प्रश्न",
    contact: "संपर्क",
    book: "कार बुक करें",
    menu: "मेनू",
    close: "बंद करें",
  },
  hero: {
    eyebrow: "दुबई में कार रेंटल",
    line1: "हर ड्राइव.",
    line2: "हर लाइफ़स्टाइल.",
    sub: "रोज़मर्रा की ड्राइव से लेकर असाधारण अनुभवों तक.",
    ctaFleet: "हमारी फ़्लीट देखें",
    ctaBook: "कार बुक करें",
    scroll: "स्क्रॉल करें",
  },
  categories: {
    all: "सभी वाहन",
    economy: "इकोनॉमी कारें",
    everyday: "रोज़मर्रा की कारें",
    sedans: "सेडान",
    suv: "एसयूवी",
    luxury: "लक्ज़री कारें",
    sports: "स्पोर्ट्स कारें",
    supercars: "सुपरकार्स",
  },
  fleet: {
    eyebrow: "कलेक्शन",
    title: "हमारी फ़्लीट",
    sub: "हमारा मौजूदा कलेक्शन — और वाहन जल्द जुड़ेंगे. उपलब्धता और कीमत पूछताछ पर कन्फ़र्म होती है.",
    priceOnRequest: "कीमत अनुरोध पर",
    perDay: "/ दिन",
    seats: "सीटें",
    transmission: "ट्रांसमिशन",
    viewDetails: "विवरण देखें",
    enquire: "अभी पूछताछ करें",
    noDeposit: "बिना डिपॉज़िट विकल्प",
    onRequest: "अनुरोध पर",
    available: "उपलब्ध",
    unavailable: "अनुपलब्ध",
    sort: "क्रमबद्ध करें",
    sortFeatured: "चुनिंदा",
    sortName: "नाम अ–ज",
    sortPriceAsc: "कीमत: कम से ज़्यादा",
    sortPriceDesc: "कीमत: ज़्यादा से कम",
    noDepositOnly: "बिना डिपॉज़िट योग्य",
    showAll: "सभी वाहन देखें",
    noResults: "इस फ़िल्टर से कोई वाहन नहीं मिला.",
    sampleNote: "बुकिंग से पहले उपलब्धता, स्पेसिफ़िकेशन और अंतिम कीमत हमेशा हमारी टीम कन्फ़र्म करती है.",
    loading: "फ़्लीट लोड हो रही है…",
    loadError: "फ़्लीट लोड नहीं हो सकी. कृपया फिर कोशिश करें.",
    retry: "फिर कोशिश करें",
  },
  modal: {
    specs: "स्पेसिफ़िकेशन",
    engine: "इंजन",
    acceleration: "0–100 किमी/घंटा",
    perDay: "प्रति दिन",
    finalNote: "अंतिम कीमत और उपलब्धता पूछताछ पर कन्फ़र्म होती है.",
    noDepositYes: "बिना डिपॉज़िट किराए के लिए योग्य (शर्तें लागू)",
    enquireVehicle: "इस कार के बारे में पूछें",
    whatsapp: "व्हाट्सऐप करें",
    close: "बंद करें",
    drag: "घुमाने के लिए खींचें",
    gallery: "गैलरी",
    view360: "360° व्यू",
    fullscreen: "फ़ुल स्क्रीन",
    exitFullscreen: "फ़ुल स्क्रीन से बाहर",
    availability: "उपलब्धता",
    previous: "पिछली तस्वीर",
    next: "अगली तस्वीर",
  },
  nodeposit: {
    eyebrow: "फ़्लेक्सिबल रेंटल",
    title: "बिना डिपॉज़िट विकल्प उपलब्ध",
    text: "दुबई में ज़्यादा फ़्लेक्सिबल रेंटल अनुभव पाएँ. बिना डिपॉज़िट विकल्प चुनिंदा वाहनों पर और कुछ शर्तों — जैसे किराया अवधि और ड्राइवर प्रोफ़ाइल — के साथ उपलब्ध हैं.",
    cta: "योग्य वाहन देखें",
    note: "केवल चुनिंदा वाहनों पर लागू. पात्रता और शर्तें पूछताछ के दौरान कन्फ़र्म की जाती हैं.",
  },
  how: {
    eyebrow: "प्रक्रिया",
    title: "कैसे काम करता है",
    steps: [
      { t: "अपनी कार चुनें", d: "रोज़मर्रा की कारों से लेकर लक्ज़री और सुपरकार तक हमारा चयन देखें." },
      { t: "अपनी पूछताछ भेजें", d: "हमें पसंदीदा वाहन और किराए की तारीखें बताएं." },
      { t: "बुकिंग कन्फ़र्म करें", d: "हमारी टीम उपलब्धता, कीमत, आवश्यकताएँ और अगले कदम कन्फ़र्म करती है." },
    ],
  },
  about: {
    eyebrow: "A&A MOTORS के बारे में",
    title1: "सिर्फ़ कार नहीं.",
    title2: "ये आपकी लाइफ़स्टाइल है.",
    p1: "A&A MOTORS में हम मानते हैं कि हर सफ़र सही कार का हक़दार है.",
    p2: "चाहे आप दुबई घूम रहे हों, बिज़नेस ट्रिप पर हों, आरामदायक रोज़ाना कार चाहते हों या परफ़ॉर्मेंस कार का अनुभव करना चाहते हों — हमारी सोच है कि आपकी अगली ड्राइव ढूँढना आसान और फ़्लेक्सिबल हो.",
    p3: "रोज़मर्रा की ज़रूरतों से लेकर असाधारण ऑटोमोटिव अनुभवों तक, हम चुनाव, सेवा और अपने तरीके से ड्राइव करने की आज़ादी पर एक ब्रांड बना रहे हैं.",
  },
  trust: {
    eyebrow: "भरोसा और पारदर्शिता",
    title: "भरोसे के साथ किराए पर लें",
    items: [
      { t: "स्पष्ट किराया शर्तें", d: "हर शर्त कन्फ़र्मेशन से पहले लिखित में साझा की जाती है." },
      { t: "पारदर्शी कीमतें", d: "कोई छिपा शुल्क नहीं — अंतिम कीमत पूछताछ पर कन्फ़र्म होती है." },
      { t: "वाहन-विशिष्ट डिपॉज़िट", d: "डिपॉज़िट या बिना डिपॉज़िट विकल्प आपके चुने वाहन पर निर्भर करता है." },
      { t: "तेज़ सहायता", d: "व्हाट्सऐप या फ़ोन पर सीधे हमसे बात करें, अपनी भाषा में." },
      { t: "सीधी पूछताछ", d: "एक फ़ॉर्म या एक मैसेज — बाक़ी हमारी टीम संभालती है." },
    ],
  },
  faq: {
    eyebrow: "जानना ज़रूरी",
    title: "अक्सर पूछे जाने वाले प्रश्न",
    items: [
      {
        q: "दुबई में कार किराए पर लेने के लिए कौन से दस्तावेज़ चाहिए?",
        a: "आमतौर पर: वैध ड्राइविंग लाइसेंस, पासपोर्ट या एमिरेट्स आईडी और भुगतान कार्ड. पर्यटकों को उनके घरेलू लाइसेंस के आधार पर इंटरनेशनल ड्राइविंग परमिट की भी ज़रूरत पड़ सकती है. सटीक आवश्यकताएँ वाहन और निवास स्थिति पर निर्भर करती हैं — हमारी टीम बुकिंग से पहले सब कन्फ़र्म करती है.",
      },
      {
        q: "क्या पासपोर्ट ज़रूरी है?",
        a: "पर्यटकों से आमतौर पर पासपोर्ट और एंट्री स्टैम्प/वीज़ा मांगा जाता है; UAE निवासी एमिरेट्स आईडी इस्तेमाल करते हैं. आवश्यकताएँ अलग हो सकती हैं और हम आपकी बुकिंग के लिए कन्फ़र्म करते हैं.",
      },
      {
        q: "क्या वैध ड्राइविंग लाइसेंस आवश्यक है?",
        a: "हाँ, हमेशा. जारी करने वाले देश के अनुसार इंटरनेशनल ड्राइविंग परमिट भी ज़रूरी हो सकता है. कुछ हाई-परफ़ॉर्मेंस वाहनों पर न्यूनतम आयु या लाइसेंस अवधि की शर्तें होती हैं.",
      },
      {
        q: "क्या बिना डिपॉज़िट रेंटल उपलब्ध है?",
        a: "हाँ, चुनिंदा वाहनों पर और विशिष्ट शर्तों के साथ. पात्रता वाहन, किराया अवधि और ड्राइवर प्रोफ़ाइल पर निर्भर करती है — किसी खास कार के लिए हमसे संपर्क करें.",
      },
      {
        q: "क्या एक दिन के लिए कार मिल सकती है?",
        a: "हाँ, कई वाहनों पर दैनिक किराया उपलब्ध है; कुछ मॉडलों पर न्यूनतम अवधि लागू हो सकती है.",
      },
      {
        q: "क्या होटल तक डिलीवरी मिल सकती है?",
        a: "दुबई के भीतर डिलीवरी — होटल, रेज़िडेंस या एयरपोर्ट — अनुरोध पर उपलब्ध कराई जा सकती है, वाहन और शेड्यूल पर निर्भर.",
      },
      {
        q: "वाहन की उपलब्धता कैसे जाँचें?",
        a: "फ़ॉर्म या व्हाट्सऐप से अपनी तारीखों के साथ पूछताछ भेजें; हमारी टीम किसी भी बुकिंग से पहले उपलब्धता और अंतिम कीमत कन्फ़र्म करती है.",
      },
      {
        q: "किराया और बीमा की शर्तें क्या हैं?",
        a: "बुनियादी बीमा आमतौर पर शामिल होता है. एक्सेस राशि, माइलेज लिमिट, ईंधन और सालिक (टोल) नीतियाँ वाहन के अनुसार अलग होती हैं. कन्फ़र्मेशन से पहले सभी शर्तें पारदर्शी रूप से साझा की जाती हैं.",
      },
    ],
  },
  form: {
    eyebrow: "बुकिंग पूछताछ",
    title: "बुकिंग का अनुरोध करें",
    sub: "बताइए क्या और कब ड्राइव करना है. हमारी टीम उपलब्धता, सटीक कीमत और आवश्यकताओं के साथ जवाब देगी.",
    name: "पूरा नाम",
    email: "ईमेल पता",
    phone: "फ़ोन नंबर",
    method: "पसंदीदा संपर्क तरीका",
    methodWhatsapp: "व्हाट्सऐप",
    methodCall: "फ़ोन कॉल",
    methodEmail: "ईमेल",
    vehicle: "पसंद का वाहन",
    vehicleAny: "कोई भी / सलाह चाहिए",
    pickup: "पिकअप तारीख",
    return: "वापसी तारीख",
    handover: "पिकअप या डिलीवरी",
    handoverPickup: "मैं खुद कार लूँगा/लूँगी",
    handoverDelivery: "मुझे डिलीवरी चाहिए (होटल / रेज़िडेंस / एयरपोर्ट)",
    message: "अतिरिक्त संदेश",
    messagePh: "फ़्लाइट विवरण, डिलीवरी पता, सवाल…",
    submit: "बुकिंग का अनुरोध करें",
    sending: "भेजा जा रहा है…",
    success: "आपकी पूछताछ तैयार है — व्हाट्सऐप सभी विवरणों के साथ खुल गया है. बस भेजें दबाएँ, हम जल्द जवाब देंगे.",
    whatsappNote: "भेजते ही व्हाट्सऐप आपकी पूछताछ के साथ खुलेगा — हमसे संपर्क का सबसे तेज़ तरीका.",
    error: "पूछताछ भेजने में समस्या हुई. कृपया फिर कोशिश करें या व्हाट्सऐप पर संपर्क करें.",
    errRequired: "यह फ़ील्ड आवश्यक है",
    errEmail: "कृपया मान्य ईमेल दर्ज करें",
    errDates: "वापसी तारीख पिकअप तारीख से पहले नहीं हो सकती",
  },
  contact: {
    eyebrow: "संपर्क",
    title: "हमसे सीधे बात करें",
    text: "उपलब्धता और कीमत जानने का सबसे तेज़ तरीका. हम व्हाट्सऐप और फ़ोन पर जवाब देते हैं.",
    whatsapp: "व्हाट्सऐप करें",
    whatsappAlt: "व्हाट्सऐप — दूसरी लाइन",
    callUs: "कॉल करें",
    uae: "UAE",
    germany: "जर्मनी",
    uaeNote: "फ़ोन कॉल",
    germanyNote: "व्हाट्सऐप और कॉल",
    copy: "कॉपी",
    copied: "कॉपी हुआ",
  },
  floating: {
    open: "संपर्क विकल्प",
    whatsapp: "व्हाट्सऐप करें",
    whatsappAlt: "व्हाट्सऐप (दूसरी लाइन)",
    callUae: "UAE कॉल करें",
    callDe: "जर्मनी कॉल करें",
  },
  footer: {
    desc: "दुबई में प्रीमियम कार रेंटल — रोज़मर्रा की ड्राइव से असाधारण अनुभवों तक.",
    fleetTitle: "फ़्लीट",
    contactTitle: "संपर्क",
    legalTitle: "कानूनी",
    socialTitle: "हमें फ़ॉलो करें",
    privacy: "गोपनीयता नीति",
    terms: "नियम व शर्तें",
    cookies: "कुकी सेटिंग्स",
    impressum: "कानूनी सूचना",
    rights: "सर्वाधिकार सुरक्षित.",
    socialPlaceholder: "आधिकारिक प्रोफ़ाइल जल्द आ रहे हैं",
  },
  cookies: {
    text: "हम आपकी भाषा याद रखने के लिए आवश्यक स्टोरेज और साइट सुधार के लिए एनालिटिक्स का उपयोग करते हैं. कोई विज्ञापन कुकीज़ नहीं.",
    accept: "स्वीकार करें",
    decline: "अस्वीकार करें",
  },
  legal: {
    privacyTitle: "गोपनीयता नीति",
    termsTitle: "नियम व शर्तें",
    impressumTitle: "कानूनी सूचना",
    backHome: "मुखपृष्ठ पर वापस",
    impressumNote: "A&A MOTORS वेबसाइट की कानूनी जानकारी. [प्रदान किया जाएगा] चिह्नित फ़ील्ड आधिकारिक पंजीकरण दस्तावेज़ मिलते ही पूरे किए जाएंगे.",
    impressumFields: [
      "ब्रांड / कंपनी नाम: A&A MOTORS",
      "संस्थापक / कानूनी प्रतिनिधि: Abadellh Aiouze · Amin Schmidt",
      "स्थान: दुबई, संयुक्त अरब अमीरात — पूरा पंजीकृत पता: [प्रदान किया जाएगा]",
      "ट्रेड लाइसेंस नंबर: [प्रदान किया जाएगा]",
      "VAT / TRN: [प्रदान किया जाएगा]",
      "सामग्री के लिए जिम्मेदार: Abadellh Aiouze · Amin Schmidt",
    ],
    privacySections: [
      { h: "हम कौन से डेटा एकत्र करते हैं", p: "बुकिंग पूछताछ भेजने पर हम आपके द्वारा दी गई जानकारी — नाम, ईमेल, फ़ोन नंबर, पसंदीदा वाहन और किराए की तारीखें — केवल आपकी पूछताछ के जवाब के लिए संसाधित करते हैं." },
      { h: "हम इसका उपयोग कैसे करते हैं", p: "आपका डेटा केवल आपकी पूछताछ संभालने और बुकिंग होने पर किराया अनुबंध तैयार करने के लिए उपयोग होता है. हम मार्केटिंग के लिए आपका डेटा बेचते या साझा नहीं करते." },
      { h: "स्टोरेज और रिटेंशन", p: "पूछताछ सुरक्षित रूप से संग्रहीत होती है और केवल आपके अनुरोध को संभालने तथा कानूनी दायित्वों तक सीमित समय के लिए रखी जाती है." },
      { h: "आपके अधिकार", p: "आप कभी भी व्हाट्सऐप या फ़ोन से संपर्क करके अपने व्यक्तिगत डेटा तक पहुँच, सुधार या हटाने का अनुरोध कर सकते हैं." },
    ],
    termsSections: [
      { h: "सामान्य", p: "ये शर्तें A&A MOTORS वेबसाइट के उपयोग को नियंत्रित करती हैं. दिखाए गए वाहन, उपलब्धता और कीमतें नमूना सामग्री हैं, जब तक व्यक्तिगत किराया अनुबंध में कन्फ़र्म न हों." },
      { h: "पूछताछ और बुकिंग", p: "पूछताछ भेजने से बुकिंग नहीं बनती. किराया अनुबंध तभी बनता है जब हमारी टीम उपलब्धता, कीमत और आवश्यकताएँ आपके साथ कन्फ़र्म करती है." },
      { h: "वाहन और कीमतें", p: "प्रदर्शित वाहन, स्पेसिफ़िकेशन और कीमतें सांकेतिक हैं. अंतिम शर्तें — डिपॉज़िट, बीमा, माइलेज और सालिक टोल सहित — बुकिंग से पहले बताई जाती हैं." },
      { h: "दायित्व", p: "हम सटीकता का प्रयास करते हैं, लेकिन यह गारंटी नहीं दे सकते कि वेबसाइट की सभी सामग्री हर समय पूर्ण और अद्यतित हो." },
    ],
  },
  admin: {
    login: "एडमिन लॉगिन",
    email: "ईमेल",
    password: "पासवर्ड",
    signIn: "साइन इन",
    signingIn: "साइन इन हो रहा है…",
    loginError: "गलत क्रेडेंशियल या बहुत अधिक प्रयास.",
    dashboard: "फ़्लीट डैशबोर्ड",
    vehicles: "वाहन",
    enquiries: "पूछताछ",
    logout: "लॉग आउट",
    addVehicle: "वाहन जोड़ें",
    edit: "संपादित करें",
    del: "हटाएं",
    save: "सहेजें",
    cancel: "रद्द करें",
    name: "नाम",
    category: "श्रेणी",
    price: "कीमत / दिन (AED, खाली = अनुरोध पर)",
    seats: "सीटें",
    transmission: "ट्रांसमिशन",
    availability: "उपलब्धता",
    noDeposit: "बिना डिपॉज़िट योग्य",
    image: "छवि URL",
    featured: "चुनिंदा",
    status: "स्थिति",
    empty: "अभी कोई पूछताछ नहीं.",
    confirmDelete: "यह वाहन हटाएं?",
    dates: "तारीखें",
    message: "संदेश",
    back: "वेबसाइट पर वापस",
    vehicleSaved: "वाहन सहेजा गया",
    vehicleDeleted: "वाहन हटाया गया",
    statusUpdated: "स्थिति अपडेट हुई",
    newVehicle: "नया वाहन",
    editVehicle: "वाहन संपादित करें",
  },
};
